import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CTooltip
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSwitchCareHomeMutation } from "pages/SubAdmins/SubAdmins.query";
import API from "service";
import { setLocalStore } from "utils/localStorage";
import { Alert } from "utils";

const CareHomeSwitcher = () => {
  const history = useHistory();
  const [switching, setSwitching] = useState(false);

  const assignedCareHomes = JSON.parse(
    localStorage.getItem("assignedCareHomes") || "[]"
  );

  const activeCareHome = JSON.parse(
    localStorage.getItem("activeCareHome") || "{}"
  );

  const { mutate: switchCareHome } = useSwitchCareHomeMutation();
  const subAdmin = JSON.parse(
  localStorage.getItem("subAdmin") || "{}"
);

  const handleSelect = (careHomeId, careHomeName) => {
    if (careHomeId === activeCareHome?.id || switching) return;
    setSwitching(true);
    API.setToken(subAdmin.token);

    switchCareHome(careHomeId, {
      onSuccess: (response) => {
        setSwitching(false);
        localStorage.setItem(
          "activeCareHome",
          JSON.stringify({
            id: response.careHomeId,
            name: response.careHomeName,
          })
        );


        localStorage.setItem(
          "isSubAdminContext",
          "true"
        );

        API.setToken(response.token);

        setLocalStore({
          identifier: response.careHomeId,
          token: response.token,
          dashboardType: response.dashboardType,
          type: "carehome",
          baseUrl: response.baseUrl,
        });

        Alert.success(
          `Switched to Care Home: ${response.careHomeName}`
        );

        setTimeout(() => {
          window.location.reload();
        }, 1200);
      },
      onError: () => {
        setSwitching(false);
      }
    });
  };

  if (assignedCareHomes.length === 0) return null;

  return (
    <CDropdown className="mr-3">
     
        <CDropdownToggle
          color="light"
          className="d-flex align-items-center"
          style={{ gap: "8px", borderRadius: "20px", fontWeight: "600", color: "#4f5d73", padding: "4px 12px" }}
          disabled={switching}
        >
          <CIcon name="cil-building" />
          <span className="d-none d-md-inline">
            {switching ? "Switching..." : (activeCareHome?.name || "Select Care Home")}
          </span>
        </CDropdownToggle>
   
      <CDropdownMenu>
        {assignedCareHomes.map((item) => (
          <CDropdownItem
            key={item.id || item.identifier}
            onClick={() => handleSelect(item.id || item.identifier, item.name)}
            active={activeCareHome?.id === (item.id || item.identifier)}
          >
            {item.name}
          </CDropdownItem>
        ))}
      </CDropdownMenu>
    </CDropdown>
  );
};

export default CareHomeSwitcher;